import {useLocation, useNavigate, useParams} from 'react-router-dom';
import PatientDetailsComponent from './component';
import {getRoute, RouteSection} from '$utils/route';
import {useMemo} from 'react';

const PatientDetailsContainer = () => {
  const location = useLocation();
  const params = useParams();
  const patientId = useMemo(() => {
    if (typeof location.state?.patientId === 'number') {
      return location.state.patientId;
    }
    if (params.patientId) {
      const id = Number(params.patientId);
      return isNaN(id) ? undefined : id;
    }
    return undefined;
  }, [location.state, params.patientId]);

  const navigate = useNavigate();
  const backRoute = useMemo(
    () => location?.state?.backRoute || getRoute(RouteSection.PatientList),
    [location?.state]
  );

  const handleBackClick = () => {
    if (backRoute) {
      navigate(backRoute);
    } else {
      navigate(getRoute(RouteSection.PatientList));
    }
  };

  if (typeof patientId !== 'number' || isNaN(patientId)) {
    return <div>Invalid patient ID</div>;
  }

  return (
    <PatientDetailsComponent
      handleBackClick={handleBackClick}
      patientId={patientId}
    />
  );
};

export default PatientDetailsContainer;
